export enum PageTitles {
  Homepage = 'Fannie Mae - Developer Portal',
  Catalog = 'Fannie Mae API Catalog',
  Support = 'Fannie Mae Developer Portal Support',
  UseCases = 'Fannie Mae Developer Portal Use Cases',
}
